import { connect } from 'react-redux'
import { compose } from 'redux'
import { withUrlResource } from 'common/utils'
import LanguageSwitcher from './LanguageSwitcher'

const mapStateToProps = ({ auth }) => ({
  permissions: auth.permissions
})

const enhanced = compose(
  withUrlResource,
  connect(mapStateToProps)
)

export default enhanced(LanguageSwitcher)
